<template>
  <div>
    <v-card flat>
      <v-card-text>
        <!-- PARTE DE ARRIBA Y FILTROS -->
        <v-row dense>
          <v-col md="6" cols="12">
            <v-card-title>
              Creador de ordenes de compra <br/> por existencias ideales
            </v-card-title>
          </v-col>
          <v-col md="3" cols="12">
            <v-btn
              @click="GoToOrdenCompra()"
              block
              class="my-2"
              color="primary"
              outlined
              >Ir a Ordenes de Compra</v-btn
            >
          </v-col>
          <v-col md="3" cols="12">
            <v-btn
              @click="verifyExistencias()"
              block
              class="my-2"
              color="success"
              outlined
              >Consultar ideales</v-btn
            >
          </v-col>
        </v-row>

        <!-- COLUMNAS -->

        <v-row v-if="idealesConsultados">
          <!-- Columna de Productos Disponibles -->
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3">
              <v-card-title
                class="headline"
                style="display: flex; justify-content: space-between"
              >
                Productos Disponibles
                <div style="display: flex; align-items: center">
                  <v-btn
                    text
                    small
                    v-if="filterCategoria || filterProduct"
                    @click="selectAllFiltered"
                  >
                    Seleccionar Todos
                  </v-btn>

                  <v-menu
                    offset-y
                    :close-on-content-click="false"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-filter</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-text-field
                          class="mt-1"
                          v-model="filterCategoria"
                          label="Filtra por Categoria"
                          hide-details
                          dense
                        ></v-text-field>
                        <v-text-field
                          class="mt-4"
                          v-model="filterProduct"
                          label="Filtrar Producto"
                          hide-details
                          dense
                        ></v-text-field>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </div>
              </v-card-title>
              <v-divider></v-divider>
              <v-virtual-scroll
                :key="refresh"
                :items="filteredProductsToImport"
                height="56vh"
                item-height="100"
                bench="5"
              >
                <template v-slot:default="{ item: producto, index }">
                  <v-card
                    flat
                    class="mb-1 px-3 pt-4"
                    :key="producto.id || index"
                    @click="toggleSelection(producto, true, true)"
                  >
                    <!-- Primera fila: Checkbox, Información del producto y Estado -->
                    <v-row class="align-center pa-0 ma-0">
                      <!-- Checkbox -->
                      <v-col cols="auto" class="py-0">
                        <v-checkbox
                          class="py-0"
                          v-model="producto.selected"
                          @click.stop
                          @change="toggleSelection(producto, true)"
                          hide-details
                          dense
                        />
                      </v-col>
                      <!-- Nombre, categoría y detalles -->
                      <v-col class="py-0">
                        <div class="font-weight-medium">
                          {{ producto.Nombre }}
                          <span class="grey--text text--darken-1">
                            ({{ producto.Categoria }})
                          </span>
                          <small>
                            Total:
                            {{
                              $pgsHelper.formatNumber(producto.ExistenciaTotal)
                            }}
                            {{ producto.UM }} | Ideal calculado:
                            {{ producto.eidl }} {{ producto.UM }}
                          </small>
                        </div>
                      </v-col>
                      <!-- Estado de cantidades -->
                      <v-col cols="auto" class="text-right py-0">
                        <div
                          v-if="producto.availableToImport"
                          class="orange--text font-weight-bold"
                        >
                          ⚠
                        </div>
                        <div
                          v-else-if="producto.askToImport"
                          class="orange--text font-weight-medium"
                        >
                          ↺
                        </div>
                        <div v-else class="green--text">✔</div>
                      </v-col>
                    </v-row>
                    <!-- Segunda fila: Almacenes (si existen) -->
                    <v-row
                      class="py-0 mt-n1"
                      v-if="Object.keys(producto.AlmacenComparacion).length"
                    >
                      <v-col class="ml-6 py-0">
                        <span class="text-caption grey--text">
                          <span
                            v-for="(
                              almacen, idx
                            ) in producto.AlmacenComparacion"
                            :key="idx"
                          >
                            {{ almacen.Nombre }}:
                            {{ $pgsHelper.formatNumber(almacen.Stock) }}
                            <span
                              v-if="
                                idx <
                                Object.keys(producto.AlmacenComparacion)
                                  .length -
                                  1
                              "
                            >
                              |
                            </span>
                          </span>
                        </span>
                      </v-col>
                    </v-row>
                  </v-card>
                </template>
              </v-virtual-scroll>
            </v-card>
          </v-col>

          <!-- Columna de Productos Seleccionados -->
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3">
              <v-card-title
                class="headline"
                style="display: flex; justify-content: space-between"
              >
                Productos seleccionados
                <div>
                  <v-btn text small color="error" @click="deleteAllSelected"
                    >Eliminar todos</v-btn
                  >
                  <v-btn text small @click="openPreview" v-if="hasPreviewData"
                    >Preview</v-btn
                  >
                  <v-menu
                    left
                    offset-y
                    :close-on-content-click="false"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-filter</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-text-field
                          v-model="filterProductSelected"
                          label="Filtrar Producto seleccionado"
                          hide-details
                          dense
                        ></v-text-field>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </div>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row justify="center">
                  <v-expansion-panels
                    accordion
                    style="max-height: 55vh; overflow-y: auto"
                  >
                    <v-expansion-panel
                      v-for="producto in filteredProductsSelected"
                      :key="producto.id"
                    >
                      <!-- encabezado del producto con información general -->
                      <v-expansion-panel-header class="px-1">
                        <div class="font-weight-medium mr-2 align-center">
                          <!-- botón para eliminar el producto de productosDisponibles -->
                          <v-btn
                            small
                            icon
                            @click.stop="deleteProds(producto.id, producto)"
                            color="error"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                          {{ producto.Nombre }}
                          <span class="grey--text text--darken-1">
                            ({{ producto.Categoria }})
                          </span>
                          <small>
                            total:
                            {{
                              $pgsHelper.formatNumber(producto.ExistenciaTotal)
                            }}
                            {{ producto.UM }} | ideal calculado:
                            {{ producto.eidl }}
                            {{ producto.UM }}
                          </small>
                        </div>
                      </v-expansion-panel-header>
                      <!-- contenido del panel con formulario y tabla -->
                      <v-expansion-panel-content>
                        <v-row>
                          <!-- formulario para agregar detalle -->
                          <v-col cols="12" md="4">
                            <v-form>
                              <!-- campo para departamento -->
                              <v-autocomplete
                                label="Departamento"
                                :items="departamentos"
                                item-text="text"
                                item-value="value"
                                hide-details
                                v-model="producto.tempDepartamento"
                              ></v-autocomplete>
                              <!-- campo para seleccionar almacen -->
                              <v-autocomplete
                                :items="almacenes"
                                item-text="Nombre"
                                hide-details
                                item-value="id"
                                label="Almacen"
                                v-model="producto.tempAlmacen"
                              ></v-autocomplete>
                              <!-- campo para cantidad -->
                              <v-text-field
                                hide-details
                                type="number"
                                :label="'Cantidad (' + producto.UM+')' "
                                v-model="producto.tempCantidad"
                              ></v-text-field>
                              <!-- botón para agregar registro -->
                              <v-btn
                                class="mt-1"
                                block
                                color="success"
                                @click="agregarDetalle(producto)"
                              >
                                agregar
                              </v-btn>
                            </v-form>
                          </v-col>
                          <!-- tabla para mostrar los registros agregados -->
                          <v-col
                            cols="12"
                            md="8"
                            style="max-height: 30vh; overflow-y: auto"
                          >
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">Departamento</th>
                                    <th class="text-left">Almacen</th>
                                    <th class="text-left">Cantidad</th>
                                    <th class="px-0"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(item, i) in producto.addedByAlmacen"
                                    :key="i"
                                  >
                                    <td>{{ item.Departamento }}</td>
                                    <td>{{ getOrigenName(item.Almacen) }}</td>
                                    <td class="text-center">
                                      {{ item.Cantidad }} {{ item.UM }}
                                    </td>
                                    <td class="px-0">
                                      <v-btn
                                        icon
                                        @click="quitarDetalle(producto, i)"
                                      >
                                        <v-icon>mdi-delete</v-icon>
                                      </v-btn>
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-card flat v-else class="text-center">
          <h3 class="mt-10">Seleccione el boton <a>Consultar Ideales</a> para continuar</h3>
        </v-card>
      </v-card-text>
    </v-card>

    <modal v-model="previewModal" fullscreen title="Ordenes a enviar">
      <v-card flat>
        <v-col class="mx-auto">
          <h4>Órdenes de Compra - Preview</h4>
          <v-divider class="my-1"></v-divider>
          <div v-if="groupedData && groupedData.length">
            <v-expansion-panels multiple>
              <v-expansion-panel
                v-for="(group, index) in groupedData"
                :key="index"
              >
                <v-expansion-panel-header disable-icon-rotate>
                  <span class="font-weight-bold">
                    {{ group.departamento }} - {{ group.nombreAlmacen }}
                  </span>
                  <template v-slot:actions>
                    <v-badge
                      color="primary"
                      :content="`Items: ${group.items.length}`"
                      class="mr-12"
                    />
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th>Nom</th>
                        <th>Cnt</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in group.items" :key="i">
                        <td>{{ item.Nombre }}</td>
                        <td>{{ item.Cantidad }} {{ item.UM }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <v-alert
            v-else
            elevation="0"
            class="mt-2"
            border="bottom"
            colored-border
            type="info"
          >
            La orden de compra está vacía.
          </v-alert>
        </v-col>
        <v-card-actions style="justify-content: flex-end">
          <v-btn @click="sendToOrders" color="success">
            Enviar órdenes de compra
          </v-btn>
        </v-card-actions>
      </v-card>
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import OrdenesCompra from "../../../clases/Inventarios/OrdenesCompra";
import { mapActions } from "vuex";
export default {
  name: "OrdenesCompraIdeales",
  data() {
    return {
      idealesConsultados: false,
      productosDisponibles: [],
      productosSeleccionados: [],
      filterCategoria: "",
      filterProduct: "",
      filterProductSelected: "",
      ProductsToImport: [],
      refresh: 0,
      almacenes: [],
      Categories: [],
      rules: {
        Requerido: [(v) => !!v || "Este campo es obligatorio"],
      },

      previewModal: false,
      groupedData: [],
      estatusList: OrdenesCompra.getStatusList(),
    };
  },
  methods: {
    async sendToOrders() {
      // Construir el array de órdenes a partir de groupedData
      const orders = this.groupedData.map((group) => ({
        Id: null,
        sts: "P",
        amc: group.almacen,
        mmt: moment().format("YYYY-MM-DD_HH:mm:ss"),
        req: group.items.map((item) => ({
          prd: item.id,
          nom: item.Nombre,
          cnt: Number(item.Cantidad),
        })),
        dpt: group.departamento,
      }));

      this.$alert.alertConfirmAll(
        {
          action: "enviar",
          obj: "las órdenes de compra",
          route: "AMC-OrdenesCompra-createOrdenCompra",
          onSuccess: ({ successCount, failedCount, failedCalls }) => {
            const messageHTML = `
          <p>Se realizaron ${successCount} órdenes exitosamente.${
              failedCount > 0 ? " Hubo " + failedCount + " errores." : ""
            }</p>
          ${
            failedCount > 0
              ? `
            <details style="margin-top:10px;">
              <summary style="cursor: pointer;">Más información</summary>
              <div style="max-height: 200px; overflow: auto; text-align: left;">
                ${failedCalls
                  .map((err, index) => {
                    const errorText =
                      err.status === "rejected"
                        ? err.reason && err.reason.message
                          ? err.reason.message
                          : "Error desconocido"
                        : err.value.data.error || "Error sin detalle";
                    return `<p><strong>Error ${
                      index + 1
                    }:</strong> ${errorText}</p>`;
                  })
                  .join("")}
              </div>
            </details>
            `
              : ""
          }
        `;

            this.$swal({
              title: "Resultado de la operación",
              html: messageHTML,
              icon: failedCount === 0 ? "success" : "warning",
              showCancelButton: true,
              confirmButtonText: "Ir a OC",
              cancelButtonText: "Cancelar",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.GoToOrdenCompra();
              }
            });
          },
        },
        orders
      );
    },
    openPreview() {
      const groups = {};
      this.filteredProductsSelected.forEach((product) => {
        if (product.addedByAlmacen && product.addedByAlmacen.length) {
          product.addedByAlmacen.forEach((entry) => {
            const key = `${entry.Departamento}-${entry.nombreAlmacen}`;
            if (!groups[key]) {
              groups[key] = {
                departamento: entry.Departamento,
                almacen: entry.Almacen,
                nombreAlmacen: entry.nombreAlmacen,
                items: [],
              };
            }
            groups[key].items.push({
              UM: product.UM,
              id: product.id,
              Nombre: product.Nombre,
              Cantidad: entry.Cantidad,
            });
          });
        }
      });

      this.groupedData = Object.values(groups);
      this.previewModal = true;
    },

    selectAllFiltered() {
      this.filteredProductsToImport.forEach((producto) => {
        if (!producto.selected) {
          // Si la propiedad 'selected' no existe, se define de forma reactiva
          if (!("selected" in producto)) {
            this.$set(producto, "selected", true);
          } else {
            producto.selected = true;
          }
          this.toggleSelection(producto, true);
        }
      });
    },
    deleteAllSelected() {
      this.productosSeleccionados.forEach((producto) => {
        producto.selected = false;
      });
      this.productosSeleccionados = [];
    },

    async verifyExistencias() {
      this.ProductsToImport = [];
      const origenesProds = this.$store.getters.getOrigenes;
      const productosGlobales = this.$store.getters.getProductos;
      const productosPorId = new Map(productosGlobales.map((p) => [p.id, p]));

      const productosExistencias = new Map();

      /* se recorren todos los almacenes */
      origenesProds.forEach((doc) => {
        const origenId = doc.Origen;
        const productos = Object.entries(doc.Productos || {});

        productos.forEach(([prodId, prodInfo]) => {
          // si el producto aún no está en el mapa, se inicializa con valores por defecto
          if (!productosExistencias.has(prodId)) {
            productosExistencias.set(prodId, {
              id: prodId,
              ExistenciaTotal: 0,
              AlmacenComparacion: {},
              existAlertTotal: { emin: 0, eidl: 0 },
            });
          }

          // se obtiene la entrada del producto en el mapa y del producto global
          const item = productosExistencias.get(prodId);
          const productData = productosPorId.get(prodId);
          if (!productData || productData.Dlat) return;

          // se suma a la existencia total
          const stock = Number(prodInfo.Stock || 0);
          item.ExistenciaTotal += stock;

          const origenInfo = this.$pgsHelper.getById(
            this.almacenes,
            "id",
            origenId
          );

          // se agrega información comparativa del almacén al producto
          item.AlmacenComparacion[origenId] = {
            id: prodId,
            Stock: stock,
            Nombre: origenInfo?.Nombre || "SinNombre",
          };

          // si existe configuración de alertas para este producto en el almacén, se acumulan los valores
          if (productData.amcs?.[origenId]) {
            item.existAlertTotal.emin += Number(
              productData.amcs[origenId].emin || 0
            );
            item.existAlertTotal.eidl += Number(
              productData.amcs[origenId].eidl || 0
            );
          }
        });
      });

      /** se adjuntan los productos de todos los almacenes */
      productosExistencias.forEach((data, id) => {
        const productData = productosPorId.get(id);
        const categoriaData = this.$pgsHelper.getById(
          this.Categories,
          "id",
          productData.Categoria
        );

        // se obtienen valores base como eidl y unidad de medida
        const eidl = productData.eidl || 0;
        const UM = productData.Extra?.AYB?.UM || "PZ";

        // se calculan las cantidades solicitadas basadas en la existencia y las alertas configuradas
        const cantToRequestTotal =
          data.existAlertTotal.eidl - data.ExistenciaTotal;
        const cantCalulated = Math.max(0, Number(eidl) - data.ExistenciaTotal);

        // se determina si el producto debe solicitarse para importar según las condiciones de existencia
        const askToImport =
          data.ExistenciaTotal >= data.existAlertTotal.emin &&
          data.ExistenciaTotal < data.existAlertTotal.eidl;
        // se determina si el producto está disponible para importar
        const availableToImport =
          data.ExistenciaTotal < data.existAlertTotal.emin;

        // se crea el objeto final del producto con toda la información necesaria
        const productoFinal = {
          id,
          Nombre: productData.Nombre,
          Categoria: categoriaData ? categoriaData.Nombre : "NoEncontrada",
          UM,
          ExistenciaTotal: data.ExistenciaTotal,
          AlmacenComparacion: data.AlmacenComparacion,
          eidl: eidl,
          existAlertTotal: this.$pgsHelper.cloneObj(data.existAlertTotal),
          cantToRequestTotal,
          cantCalulated,
          cantToRequest: cantToRequestTotal,
          askToImport,
          availableToImport,
          selected: false,
        };

        this.ProductsToImport.push(productoFinal);
      });

      // primero se ordena de mayor a menor por askToImport,
      // luego por availableToImport y finalmente alfabéticamente por Nombre
      this.ProductsToImport = this.ProductsToImport.sort(function (a, b) {
        return (
          b.askToImport - a.askToImport ||
          b.availableToImport - a.availableToImport ||
          a.Nombre.localeCompare(b.Nombre)
        );
      });

      // console.log("this.ProductsToImport", this.ProductsToImport);
      this.productosSeleccionados = [];

      this.idealesConsultados = true;
      this.selectAllIdeal(1);
    },

    // método para agregar detalle al producto
    agregarDetalle(producto) {
      if (!producto.addedByAlmacen) {
        this.$set(producto, "addedByAlmacen", []);
      }
      if (
        !producto.tempDepartamento ||
        !producto.tempAlmacen ||
        !producto.tempCantidad
      ) {
        return;
      }
      // buscar si ya existe un registro con la misma combinación de departamento y almacén
      const registroExistente = producto.addedByAlmacen.find(
        (item) =>
          item.Departamento === producto.tempDepartamento &&
          item.Almacen === producto.tempAlmacen
      );
      if (registroExistente) {
        // si existe, se suma la cantidad a la cantidad ya registrada
        registroExistente.Cantidad =
          Number(registroExistente.Cantidad) + Number(producto.tempCantidad);
      } else {
        // si no existe, se agrega un nuevo registro al arreglo
        const nombreAlmacen = this.$pgsHelper.getById(
          this.almacenes,
          "id",
          producto.tempAlmacen
        ).Nombre;
        producto.addedByAlmacen.push({
          UM: producto.UM,
          Departamento: producto.tempDepartamento,
          Almacen: producto.tempAlmacen,
          nombreAlmacen: nombreAlmacen,
          Cantidad: producto.tempCantidad,
        });
      }
      // se limpian los campos temporales del formulario
      producto.tempDepartamento = "";
      producto.tempAlmacen = null;
      producto.tempCantidad = null;
    },

    // método para quitar un registro del detalle del producto
    quitarDetalle(producto, index) {
      if (producto.addedByAlmacen) {
        producto.addedByAlmacen.splice(index, 1);
      }
    },
    // método para obtener el nombre del almacen a partir de su id
    getOrigenName(id) {
      const origen = this.almacenes.find((o) => o.id === id);
      return origen ? origen.Nombre : "no encontrado";
    },

    toggleSelection(producto, addToSelected, toggleManually = false) {
      if (toggleManually) {
        producto.selected = !producto.selected;
      }

      if (addToSelected) {
        if (producto.selected) {
          if (
            !this.productosSeleccionados.find((prod) => prod.id === producto.id)
          ) {
            this.productosSeleccionados.push(producto);
          }
          this.productosDisponibles = this.productosDisponibles.filter(
            (prod) => prod.id !== producto.id
          );
        } else {
          this.productosSeleccionados = this.productosSeleccionados.filter(
            (prod) => prod.id !== producto.id
          );
        }
      } else {
        if (!producto.selected) {
          if (
            !this.productosDisponibles.find((prod) => prod.id === producto.id)
          ) {
            this.productosDisponibles.push(producto);
          }
          this.productosSeleccionados = this.productosSeleccionados.filter(
            (prod) => prod.id !== producto.id
          );
        }
      }
    },

    // función para eliminar un producto tanto de productosDisponibles como de productosSeleccionados
    deleteProds(id, producto) {
      producto.selected = false;
      this.productosDisponibles = this.productosDisponibles.filter(
        (prod) => prod.id !== id
      );
      // se elimina el producto del array de productos seleccionados
      this.productosSeleccionados = this.productosSeleccionados.filter(
        (prod) => prod.id !== id
      );
    },

    selectAllIdeal(option) {
      this.ProductsToImport.forEach((prod) => {
        if (option == 1) {
          prod.cantToRequest = Number(prod.cantToRequestByAlmacen);
        } else if (option == 2) {
          prod.cantToRequest = Number(prod.cantToRequestByTotal);
        } else {
          prod.cantToRequest = Number(prod.cantCalulated);
        }
      });
      this.refresh++;
    },

    GoToOrdenCompra() {
      this.$router.push({
        path: "/productos-inventarios/orden-compra-insumo",
      });
    },

    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    async getAlmacenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          // Departamentos: element[1]["Departamentos"],
        });
      });

      this.almacenes = origenes;
    },
  },
  computed: {
    hasPreviewData() {
      return this.filteredProductsSelected.some(
        (producto) =>
          producto.addedByAlmacen && producto.addedByAlmacen.length > 0
      );
    },
    departamentos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    filteredProductsToImport() {
      return this.ProductsToImport.filter((producto) => {
        const matchesName = this.filterProduct
          ? producto.Nombre.toLowerCase().includes(
              this.filterProduct.toLowerCase()
            )
          : true; // Si no está activo devuelve todos

        const matchesCategory = this.filterCategoria
          ? producto.Categoria.toLowerCase().includes(
              this.filterCategoria.toLowerCase()
            )
          : true; // Si no está activo devuelve todos

        // Si ambos filtros están activos, requiere que coincidan ambos
        if (this.filterProduct && this.filterCategoria) {
          return matchesName && matchesCategory;
        }

        // Si solo uno está activo, filtra por ese
        return matchesName && matchesCategory;
      });
    },
    filteredProductsSelected() {
      return this.productosSeleccionados.filter((producto) => {
        const matchesName = this.filterProductSelected
          ? producto.Nombre.toLowerCase().includes(
              this.filterProductSelected.toLowerCase()
            )
          : true; // Si no está activo devuelve todos

        return matchesName;
      });
    },
  },
  async mounted() {
    await this.getAlmacenes();
    await this.getCategories();
  },
};
</script>
